const pages = require("../content/publicPages.json");
const ORIGIN = "https://ibt-practice.com";

function routeMetadata(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return { ...pages.home, path, index: true };
  if (path === "/guide") return { ...pages.guide, path, index: true };
  if (/^\/bar-exam\/\d+\/statistics$/.test(path)) {
    // Do not put noindex on a public statistics page while its API is loading.
    return { title: "모의고사 통계 | IBT 연습장", description: "시험별 응시 통계와 점수 분포, 문항별 정답률을 확인하세요.", path, index: true };
  }
  const titles = {
    "/bar-exam": "모의고사 선택", "/login": "로그인", "/signup": "회원가입",
    "/agreement": "이용약관 동의", "/agreement_retroactive": "이용약관 재동의",
    "/answers": "내 답안지", "/answers/new": "주관식 답안 작성",
    "/bar-exam/result": "내 채점 결과", "/policy": "서비스 이용약관", "/privacy": "개인정보 처리방침",
  };
  const title = titles[path] || (/^\/answers\/[^/]+$/.test(path) ? "답안 작성" :
    /^\/bar-exam\/[^/]+\/answer$/.test(path) ? "객관식 답안 입력" :
    /^\/view\/[^/]+$/.test(path) ? "공유 답안 보기" : "페이지를 찾을 수 없습니다");
  const index = path === "/policy" || path === "/privacy";
  return { title: `${title} | IBT 연습장`, description: `IBT 연습장의 ${title} 페이지입니다.`, path, index };
}

function applyMetadata(metadata) {
  document.title = metadata.title;
  document.documentElement.lang = "ko";
  const setMeta = (attribute, key, value) => {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
      element = document.createElement("meta");
      element.setAttribute(attribute, key);
      document.head.appendChild(element);
    }
    element.content = value;
  };
  setMeta("name", "description", metadata.description);
  setMeta("name", "robots", metadata.index ? "index, follow" : "noindex, follow");
  setMeta("property", "og:title", metadata.title);
  setMeta("property", "og:description", metadata.description);
  setMeta("property", "og:url", ORIGIN + metadata.path);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  // Private IDs and input/result URLs do not need to become canonical content URLs.
  if (!metadata.index) {
    if (canonical) canonical.remove();
  } else {
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = ORIGIN + metadata.path;
  }
}
module.exports = { ORIGIN, routeMetadata, applyMetadata };
